import { render } from "./ReportsDeparturesTable.vue?vue&type=template&id=546bf601&ts=true"
import script from "./ReportsDeparturesTable.vue?vue&type=script&lang=ts"
export * from "./ReportsDeparturesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__